enum RequiredDriverProperties {
	None = 0,
	Fullname = 1,
	LicenseNumber = 2
}

export default RequiredDriverProperties;
